export function getInputTypeByCountry(countryCode: string): 'number' | 'tel' | 'text' {
    switch (countryCode) {
        case 'NO':
        case 'DK':
        case 'SE':
            return 'number';
        case 'FI':
            return 'tel';
        default:
            return 'text';
    }
}
